<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3327 6.66699V8.00033M18.666 8.00033V6.66699M13.3327 13.867V10.667C13.3327 9.95975 13.6136 9.28147 14.1137 8.78137C14.6138 8.28128 15.2921 8.00033 15.9993 8.00033C16.7066 8.00033 17.3849 8.28128 17.885 8.78137C18.3851 9.28147 18.666 9.95975 18.666 10.667V13.867M9.33268 20.0003H5.33268L2.66602 23.3337M9.89268 22.667L6.66602 26.667L7.99935 29.3337M10.666 16.0003L5.33268 14.667L2.66602 10.667M11.9993 14.667L7.33268 8.00033L9.33268 2.66699"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6654 24.0007C9.92252 23.0102 9.47016 21.8324 9.35897 20.5994C9.24779 19.3663 9.48217 18.1266 10.0359 17.0192C10.5895 15.9119 11.4407 14.9805 12.4938 14.3296C13.547 13.6787 14.7606 13.334 15.9987 13.334C17.2368 13.334 18.4504 13.6787 19.5036 14.3296C20.5567 14.9805 21.4079 15.9119 21.9615 17.0192C22.5152 18.1266 22.7496 19.3663 22.6384 20.5994C22.5272 21.8324 22.0749 23.0102 21.332 24.0007C21.332 24.0007 18.6654 28.0007 15.9987 29.334C13.332 28.0007 10.6654 24.0007 10.6654 24.0007Z"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 14.667L24.6667 8.00033L22.6667 2.66699M21.3333 16.0003L26.6667 14.667L29.3333 10.667M22.6667 20.0003H26.6667L29.3333 23.3337M22.0933 22.667L25.3333 26.667L24 29.3337"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ExoticPetIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
